import { $$, on, doc } from './util.js';
import { readSettings, writeSettings, SETTINGS_KEY } from './settings.js';

/* TEMPLATE CODE: the Smarty / Twig switch (components/hub-template-code.html)
   --------------------------------------------------------------------------
   Every Template code component on a page shows the same engine, and the
   choice follows the reader to every other page and open tab: it is the
   `templateEngine` property of the shared settings entry (settings.js).

   Which panel shows is decided by CSS from html[data-tpl-engine], which the
   pre-paint script in base-template.html sets from the saved setting before
   first paint, so a Twig reader never sees Smarty flash first. This module
   only keeps that attribute, aria-selected and the setting in step. Without
   JavaScript the attribute is absent and both engines show, labelled. */

var ENGINES = ['smarty', 'twig'];

function current() {
	var engine = doc.documentElement.getAttribute('data-tpl-engine');
	return ENGINES.indexOf(engine) === -1 ? 'smarty' : engine;
}

function sync(engine) {
	$$('[data-tpl-code] .tpl-seg').forEach(function (tab) {
		var selected = tab.getAttribute('data-engine') === engine;
		tab.setAttribute('aria-selected', selected ? 'true' : 'false');
		tab.tabIndex = selected ? 0 : -1;
	});
}

function show(engine, save) {
	if (ENGINES.indexOf(engine) === -1) { return; }
	doc.documentElement.setAttribute('data-tpl-engine', engine);
	sync(engine);
	if (save) { writeSettings({ templateEngine: engine }); }
}

export function initTemplateCode() {
	var tabs = $$('[data-tpl-code] .tpl-seg');
	if (!tabs.length) { return; }
	sync(current());

	tabs.forEach(function (tab) {
		on(tab, 'click', function () { show(tab.getAttribute('data-engine'), true); });
		on(tab, 'keydown', function (e) {
			if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') { return; }
			e.preventDefault();
			var next = current() === 'smarty' ? 'twig' : 'smarty';
			show(next, true);
			var target = tab.parentNode.querySelector('.tpl-seg[data-engine="' + next + '"]');
			if (target) { target.focus(); }
		});
	});

	// Another tab changed the engine: follow it, without writing it back.
	on(window, 'storage', function (e) {
		if (e.key && e.key !== SETTINGS_KEY) { return; }
		var engine = readSettings().templateEngine;
		if (ENGINES.indexOf(engine) !== -1 && engine !== current()) { show(engine, false); }
	});
}
